export default "__VITE_ASSET__Cku0rsN___"